import React, { useEffect } from "react"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { useCheckRoutingInfoQueryCache } from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { useGetRegistrationJourney } from "#/components/carrot-plans/hooks/useGetRegistrationJourney"

export default function JourneyStageDecisionStep(): JSX.Element {
  const { send } = useStateMachine()

  const routingData = useCheckRoutingInfoQueryCache()
  const registrationJourneyQuery = useGetRegistrationJourney()

  const hasExistingRoutingJourneyStage = Boolean(routingData?.journeyStage)
  const hasRegistrationJourneyStage = Boolean(registrationJourneyQuery?.data?.journeyStage)
  const journeyChanged = registrationJourneyQuery?.data?.journey !== routingData?.journey

  const shouldShowJourneyStageCheckInScreen =
    hasRegistrationJourneyStage && !hasExistingRoutingJourneyStage && !journeyChanged

  useEffect(() => {
    if (!registrationJourneyQuery.isLoading) {
      send(shouldShowJourneyStageCheckInScreen ? "YES" : "NO")
    }
  }, [registrationJourneyQuery.isLoading, shouldShowJourneyStageCheckInScreen, send])

  return <></>
}
